// extracted by mini-css-extract-plugin
export default {"time":"EventTime_time--l2M","table":"EventTime_table--UsK"};